import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions
} from '../../fundamentals/text-styles/constants'

const checkboxVariantOptions = {
  STANDARD: 'standard',
  EMPHASIS: 'emphasis',
  ERROR: 'error'
}

const checkboxSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}

const checkboxStyleOptions = {
  [checkboxSizeOptions.SMALL]: {
    container: {
      ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']],
      gap: '4px'
    },
    root: {
      borderWidth: '1px',
      borderRadius: '1px',
      height: '12px',
      width: '12px'
    }
  },

  [checkboxSizeOptions.MEDIUM]: {
    container: {
      ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']],
      gap: '6px'
    },
    root: {
      borderWidth: '2px',
      borderRadius: '2px',
      height: '16px',
      width: '16px'
    }
  },

  [checkboxSizeOptions.LARGE]: {
    container: {
      ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']],
      gap: '8px'
    },
    root: {
      borderWidth: '3px',
      borderRadius: '3px',
      height: '24px',
      width: '24px'
    }
  }
}

export { checkboxVariantOptions, checkboxSizeOptions, checkboxStyleOptions }
